<template>
    <div class="modal fade" data-backdrop="static" data-keyboard="false"  id="password_modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row px-4 justify-content-end">
                        <button type="button" @click="hideModal" class="btn btn-sm btn-circle btn-icon bg-white">
                            <i class="fa fa-times "></i>
                        </button>
                    </div>
                    <div class="row pr-4 pb-4 w-100">
<!--                        <label>{{message}}</label>-->
                        <div class="d-flex">
                            <div class="d-flex">
                                <div class="col-1 mx-3">
                                    <button class="form-control"
                                            style="width: fit-content"
                                            type="button"
                                            @click="togglePassword"
                                    >
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>
                                <div class="col-10">
                                    <input name="wallet_password"
                                           :type="password_type"
                                           id="wallet_password"
                                           class="form-control"
                                           :placeholder="$t('label.current_wallet_password')"
                                           v-model="modal_wallet_password"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex px-1 justify-content-end mb-3">
                        <button @click="hideModal()"
                                class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px">انصراف
                        </button>
                        <button @click="$emit('sendOtpCode', modal_wallet_password)" id="send_button"
                                :disabled="loading"
                                class="btn btn-primary btn-sm rounded-pill px-5 py-2 mr-2  font-weight-bold"
                                style="font-size: 14px">
                            <span v-if="loading" class="spinner-border"></span>
                            <span v-else>تایید</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import {TwoFactorType} from "@/constants/TwoFactorType";
import { walletService } from '@/common/api.service';
import Approve from '@/components/elements/modal/otp-modal.vue';

export default {
    name: "password-modal",
    components: { Approve },
    computed: {
        TwoFactorType() {
            return TwoFactorType
        }
    },
    data() {
        return {
            password_type: 'password',
            modal_wallet_password: '',
        }
    },
    props: {
        message: {
            required: true
        },
        two_factor_type: {
            required: false,
            default: TwoFactorType.SMS
        },
        data: {
            required: false,
            default: null
        },
        loading: {
            required: false,
            default: false
        },
    },
    methods: {
        hideModal() {
            $('#password_modal').modal('hide');
        },
        emitAction(data) {
            this.$emit('emitAction', data.replace(/\s+/g, ''))
        },
        togglePassword() {
            this.password_type = this.password_type === 'password' ? 'text' : 'password';
        },
    },
}
</script>
<style scoped>
    a {
        color: #0f9af0 !important;
        cursor: pointer;
    }

    a:hover{
        border-bottom: 1px solid #0f9af0;
    }
</style>